import { render, staticRenderFns } from "./DrugDashboard.vue?vue&type=template&id=17460f31&scoped=true"
import script from "./DrugDashboard.vue?vue&type=script&lang=ts"
export * from "./DrugDashboard.vue?vue&type=script&lang=ts"
import style0 from "./DrugDashboard.vue?vue&type=style&index=0&id=17460f31&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17460f31",
  null
  
)

export default component.exports